import * as React from "react"

function LeafGroup(props) {
  return (
    <svg
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="35.54 25.64 241.55 274.68"
      {...props}
    >
      <path
        d="M229.083 79.2l2.703 13.135c-21.088 24.001-44.041 43-66.582 57.978l-3.462-23.434-5.345 29.1C93.092 195.384 35.542 203.78 35.542 203.78c8.399-23.081 18.356-43.165 29.358-60.666l15.994 3.526-12.136-9.473c38.669-58.192 89.049-86.14 130.596-99.471l13.442 8.811-7.965-10.513c41.105-12.195 72.257-10.24 72.257-10.24-11.658 22.664-25.642 43.612-41.72 62.495l-6.285-9.049z"
        fill="#BBF0D2"
      />
      <path
        d="M270.566 28.826S110.34 103.874 40.139 199.4c0 0 55.68-75.885 230.427-170.574z"
        fill="#E6FFF1"
      />
      <path
        d="M219.129 58.124l-25.813-12.506 23.111 12.79 2.702-.284zM190.202 76.007l-17.069 45.596 13.923-44.845 3.146-.751zM165.795 90.597l-34.098-8.985 30.991 10.168 3.107-1.183zM125.802 119.289l-16.98 39.625 19.917-42.146-2.937 2.521zM97.692 139.211l-19.297-3.63 18.829 5.549.468-1.919zM77.834 160.228l-4.613 15.482 2.362-16.4 2.251.918z"
        fill="#E6FFF1"
      />
      <path
        d="M234.625 104.279l8.119 10.673c-8.631 30.761-21.106 57.82-34.951 81.074l-13.258-19.63 7.77 28.549c-40.03 62.911-88.285 95.376-88.285 95.376-2.412-24.442-2.123-46.857.227-67.396l15.945-3.739-15.04-3.292c9.691-69.192 43.023-116.184 74.716-146.175l15.931 2.13-11.73-6.034c31.786-28.776 60.717-40.49 60.717-40.49-.706 25.477-4.253 50.413-10.58 74.394l-9.581-5.44z"
        fill="#B8E2CA"
      />
    </svg>
  )
}

export default LeafGroup
